import { Nav, Footer, Hinomaru } from "@/components/Nav";
import { Mail, MessageSquare, FileText } from "lucide-react";
import { WhatsAppLink, WhatsAppIcon, buildWhatsAppUrl, WA_DISPLAY } from "@/components/WhatsApp";
import { useLang } from "@/i18n/LanguageContext";

export default function Contatti() {
    const { t, lang } = useLang();
    return (
        <div className="min-h-screen bg-[#15181C] text-[#F4F2ED]">
            <Nav />
            <div className="max-w-3xl mx-auto px-5 md:px-8 py-10">
                <div className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD] mb-2">{t("contatti.eyebrow")}</div>
                <h1 className="font-display text-5xl md:text-6xl uppercase mb-8">{t("contatti.title1")}<br /><span className="text-[#E2231A]">{t("contatti.title2")}</span></h1>

                {/* WhatsApp — canale rapido in evidenza */}
                <a
                    href={buildWhatsAppUrl(lang)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contatti-whatsapp-card"
                    className="block mb-6 border-l-4 border-[#25D366] bg-[#25D366]/8 hover:bg-[#25D366]/15 p-5 transition-colors duration-150 group"
                >
                    <div className="flex items-center gap-4">
                        <div className="text-[#25D366]"><WhatsAppIcon size={36} /></div>
                        <div className="flex-1">
                            <div className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD] mb-1">{lang === "en" ? "Fastest channel" : "Canale più veloce"}</div>
                            <div className="font-display text-2xl md:text-3xl uppercase group-hover:text-[#25D366] transition-colors">WhatsApp — {lang === "en" ? "Chat with us" : "Scrivici ora"}</div>
                            <div className="text-xs text-[#9AA2AD] mt-1">{lang === "en" ? "Click to open a chat with pre-filled message" : "Clicca per aprire una chat con messaggio precompilato"}</div>
                        </div>
                    </div>
                </a>

                <div className="grid md:grid-cols-2 gap-4 mb-10">
                    <ContactCard icon={<Mail strokeWidth={1.5} />} title={t("contatti.c1t")} value="supporto@velorajdm.com" href="mailto:supporto@velorajdm.com" note={t("contatti.c1n")} />
                    <ContactCard icon={<MessageSquare strokeWidth={1.5} />} title={t("contatti.c2t")} value="info@velorajdm.com" href="mailto:info@velorajdm.com" note={t("contatti.c2n")} />
                    <ContactCard icon={<FileText strokeWidth={1.5} />} title={t("contatti.c3t")} value="privacy@velorajdm.com" href="mailto:privacy@velorajdm.com" note={t("contatti.c3n")} />
                </div>

                <div className="border border-[#9AA2AD]/20 bg-[#1C2026] p-6">
                    <div className="flex items-center gap-3 mb-3">
                        <Hinomaru size={24} />
                        <h2 className="font-display text-2xl uppercase">{t("contatti.fiscalTitle")}</h2>
                    </div>
                    <p className="text-sm text-[#9AA2AD]" dangerouslySetInnerHTML={{ __html: t("contatti.fiscalBody") }} />
                </div>

                <div className="mt-8 border-l-4 border-[#E2231A] pl-4 py-2">
                    <div className="text-xs uppercase tracking-widest text-[#9AA2AD]">{t("contatti.srtLabel")}</div>
                    <p className="text-sm" dangerouslySetInnerHTML={{ __html: t("contatti.srtBody") }} />
                </div>
            </div>
            <Footer />
        </div>
    );
}

const ContactCard = ({ icon, title, value, href, note }) => (
    <div className="border border-[#9AA2AD]/20 bg-[#1C2026] p-5">
        <div className="flex items-center gap-3 text-[#E2231A] mb-2">{icon}<span className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD]">{title}</span></div>
        {href ? <a href={href} className="font-display text-lg break-all hover:text-[#E2231A] transition-colors">{value}</a> : <div className="font-display text-lg">{value}</div>}
        {note && <p className="text-xs text-[#9AA2AD] mt-2">{note}</p>}
    </div>
);
